'use strict';


// newsletter modal

if (localStorage) {
  setTimeout(function() {
    if (localStorage.getItem('NewsletterModalHide') !== 'true') {
      $('.modal-container').addClass('active');
    }
  }, 5000);
}

$(document).ready(function () {

  if("NewsletterModalHide" in localStorage){
    console.log('newsletterModal = hidden')
  } else {
    console.log('newsletterModal = not hidden')
  }
  
  $('.modal-container .hide-modal').click(function() {
    localStorage.setItem('NewsletterModalHide', 'true');
    $('.modal-container').removeClass('active');
    $('.modal-container').css({"display": "none"});
  });

});

// quantity select

$(document).ready(function () {
  
  var $btnIncrease = $('.quantity-select .btn-increase');
  var $btnDecrease = $('.quantity-select .btn-decrease');
  
  $btnDecrease.click(function () {
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) - 1;
      count = count < 1 ? 1 : count;
      $input.val(count);
      $input.change();
      return false;
  });
  
  $btnIncrease.click(function () {
      var $input = $(this).parent().find('input');
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      return false;
  });

});

// localisation menu

$(document).ready(function () {
  
  $('.localisation-toggle').click(function() {
    $('.localisation-window').addClass('active');
  });
  
  $('.localisation-darkbox').click(function() {
    $('.localisation-window').removeClass('active');
  });

  $('.mobile-localisation-toggle').click(function() {
    $('.localisation-window').addClass('active');
  });
  
  $('.current-localisation').click(function() {
    $(this).toggleClass('active');
    $('.localisation-menu').toggleClass('active');
  });
  
  $('.localisation-menu .localisation-item').on('click', function(e) {
    
    const form = $('#localization_form');
    var localisation = $(this).attr('data-localisation');
    
    e.preventDefault;
    alert(localisation);
    form.submit();
    
  });
  
  $('.close-window').click(function() {
    $('.localisation-window').removeClass('active');
  });
  
});

// sticky header

(function sticky(){
  
    window.addEventListener('scroll', () => {

        const scrollAmount = window.scrollY;
        let element = document.getElementById('shopify-section-global-header');

        if (scrollAmount > 40) {
            element.classList.add('stuck');
        } else {
            element.classList.remove('stuck');
        }

    });

})();


// megamenu

$(document).ready(function () {
  
  var timer;
  $('.global-nav-item').on({
     
    'mouseover': function () {
        var navItem = this;
        timer = setTimeout(function () {
          $(navItem).addClass('active');
          $('.global-megamenu').addClass('active');
          $("div[id=" + $(navItem).attr("data-related") + "]").addClass('active');
        }, 200);
     },

     'mouseout' : function () {
        var navItem = this;
       	$(navItem).removeClass('active');
        $('.global-megamenu').removeClass('active');
        $("div[id=" + $(navItem).attr("data-related") + "]").removeClass('active');
        clearTimeout(timer);
     }
    
  });
  
  $('.megamenu').mouseover(function() {
    $(this).addClass('active');
    $('.global-megamenu').addClass('active');
    $("a[data-related=" + $(this).attr("id") + "]").addClass('active');
  });

  $('.megamenu').mouseout(function() {
    $(this).removeClass('active');
    $('.global-megamenu').removeClass('active');
    $("a[data-related=" + $(this).attr("id") + "]").removeClass('active');
  });
  
});
  
// mobile nav menu

$(document).ready(function () {
  
  $('.mobile-menu-toggle').click(function() {
    $('#global-mobile-nav').toggleClass('active');
    $('.darkbox').toggleClass('active');
    $('.mobile-search-form').removeClass('active');
  });
  
  $('.mobile-menu-header .close').click(function() {
    $('#global-mobile-nav').removeClass('active');
    $('.darkbox').removeClass('active');
  });
  
  $('.darkbox').click(function() {
    $(this).removeClass('active');
    $('#global-mobile-nav').removeClass('active');
    $('.minibag').removeClass('active');
  });
  
  $('.top-level').click(function() {
    $(this).parent().find('.second-level-mobile-menu').addClass('active');
  });
  
  $('.mobile-nav-back').click(function() {
    $(this).parent().removeClass('active');
  });
  
  $('.mobile-search').click(function() {
    $('.mobile-search-form').toggleClass('active');
    $('.mobile-search-form input[type="text"]').focus();
  });

});


// minibag

$(document).ready(function () {
  
  $('.minibag-toggle').click(function() {
    $('.minibag').toggleClass('active');
    $('.darkbox').toggleClass('active');
    $('.mobile-search-form').removeClass('active');
  });
  
  $('.minibag .close').click(function() {
    $('.minibag').removeClass('active');
    $('.darkbox').removeClass('active');
  });
  
  // minibag functions
  
  function ajaxSubmitMinicart(cart) {
    var $cart = $('.minicart-form');
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $('.minicart-form').serialize(),
      success: function (data) {
        ajaxUpdateMinicart(data);
      }
    });
  }
  
  function refreshMinicart(cart) {
    $('.cart-count').empty();
    var $cart = $('.minicart-form');
    var value = $('.global-cart-count').text() || '0';
    var currentCurrency = '';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var discounted_price_total = 0;
    var total_savings = 0;

     // cart item
    
    if (cart.item_count == 0) {
      
      cart_items_html +=
      '<div class="pocket empty-bag">' +
        '<h1><span>Your bag is</span> empty</h1>' +
      '</div>';

    } else {
      
      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        
        // minicart item html
        cart_items_html +=
        '<li class="item">' +

          '<div class="item-image">' +
            '<a href="' + item.url +'">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</a>' +
          '</div>' +

          '<div class="item-details">' +
            '<a href="' + item.url +'" title="' + item.title +'">' + '<h4 class="item-title">' + item.title +'</h4>' + '</a>' +
            '<span class="item-price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>' +
            '<div class="product-quantity-box">' +
               '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
               '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
               '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
            '</div>' +
          '</div>' +

        '</li>';
        //
        
      });
      
    }

    // update cart items
    $('.js-cart_items').html(cart_items_html);
    
    // update cart count
  	$('.global-cart-count').text(value.replace(/[0-9]+/,cart.item_count));
    
    // update cart subtotal
    $('.global-subtotal .money').html(Shopify.formatMoney(cart.total_price, $('body').data('money-format')));
    
    // update discount message
    
    
  }
  
  function ajaxUpdateMinicart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshMinicart(data);        
      }
    });
  }
  
  // trigger minibag functions
  
  $('body').on("change", ".minicart-form .quantity", function() {
    
    ajaxUpdateMinicart(
      $(this).data('line-id'),
      $(this).val(),
      $(this).parents('.minicart-form')
    );
    
    ajaxSubmitMinicart();
    
  });
  
});


// global banner

$(document).ready(function () {

  var $carousel = $('#global-banner');
  var $carouselSlides = $carousel.find('.item');

  if ( $carouselSlides.length < 2 ) {
    $carousel.addClass('only-slide');
  }

});


// home splash

$(document).ready(function () {

  var $carousel = $('.home-splash');
  var $carouselSlides = $carousel.find('.item');

  if ( $carouselSlides.length < 2 ) {
    $carousel.addClass('only-slide');
  }

  $('.home-splash').flickity({
    autoPlay: 3000,
    cellAlign: 'center',
    contain: true,
    imagesLoaded: true,
    lazyLoad: true,
    wrapAround: true
  });

});


// featured collection

$(document).ready(function () {

  $('.featured-collection-carousel').flickity({
    autoPlay: 3000,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    lazyLoad: true,
    wrapAround: true
  });

});


// accordions

$(document).ready(function () {
  
  $('.faq-accordion .faq-question .question').click(function() {
    $(this).parent().toggleClass('active');
  });

  $('.faq-accordion .faq-subcategory').click(function() {
    $(this).toggleClass('active');
    $(this).nextUntil('.faq-subcategory').toggle();
  });

  $('.footer-accordion .footer-block .footer-block-title').click(function() {
    $(this).parent().toggleClass('active');
  });

});